var React = require('react');

function UserProfileCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 16.4L1.0003 13.6997C1.00047 12.2086 2.20925 11 3.7003 11H9.09989M11.35 13.25L12.25 14.15L15.4 11M10 4.7C10 6.19117 8.79117 7.4 7.3 7.4C5.80883 7.4 4.6 6.19117 4.6 4.7C4.6 3.20883 5.80883 2 7.3 2C8.79117 2 10 3.20883 10 4.7Z","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

UserProfileCheck.defaultProps = {"width":"20","height":"20","viewBox":"0 0 18 18","fill":"none"};

module.exports = UserProfileCheck;

UserProfileCheck.default = UserProfileCheck;
